<template>
    <div class="loading-mask" v-loading="yjctrl" element-loading-text="您已拖欠运营商佣金，为了不影响正常使用，请尽快补交！">
        <div class="breadcrumb-layout">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">服务调度管理</el-breadcrumb-item>
                <el-breadcrumb-item>服务请求单列表</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="org-tree-layout">
            <swb-popover-org-tree :showIncludeSubComs="true" :initIncludeSubComs="initIncludeSubComs" @notity-change="checkComCatChange($event)"></swb-popover-org-tree>
        </div>
        <div name="query-sort-block">
            <swb-query-sort-area ref="query_model_ctrl" :confKey="confKey" :onConfigReady="onConfigReady" :configAuto="configAuto" :queryHandler="queryHandler"></swb-query-sort-area>
        </div>
        <swb-result-table name="result_table" :btnColBaseCount="2" :btnColMoreTitle="'更多操作'" ref="result_table" :confKey="confKey" :configAuto="configAuto" :needPager="needPager" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect" :rowKeyPropName="rowKeyPropName" :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :height="theTableHeight" :pageNoChangeHandler="pageNoChangeHandler" :rowDblClickHandler="rowDblClickHandler"></swb-result-table>
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, DomSizeWatcher, Routes } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf'
    import { openDeviceRepairRecDlg } from '../workVoucher/showDetailDlg'

    import userApi from '../../api/user'
    import servcDisptApi from '../../api/servcDispt'
    import merchtComnApi from '../../api/merchtComn'
    import servicerApi from '../../api/servicer'

    import SwbAppointStore from './ServcReqAppointStore';
    import { checkUserActionPerm } from '../index'

    Vue.regist(SwbAppointStore);

    import SwbServcReqVoucherLook from './ServcReqVoucherLook';
    Vue.regist(SwbServcReqVoucherLook);

    import SwbServcReqVoucherSave from './ServcReqVoucherSave';
    Vue.regist(SwbServcReqVoucherSave);

    import SwbServcWorkVoucherList from '../workVoucher/ServcWorkVoucherList';
    Routes.add(SwbServcWorkVoucherList);

    import SwbServcReqVoucherSearch from './ServcReqVoucherSearch';
    Vue.regist(SwbServcReqVoucherSearch);

    import SwbPopoverOrgTree from '../orgStruct/PopoverOrgTree';
    Vue.regist(SwbPopoverOrgTree);

    import SwbResultColConf from '../query/ResultColConf.vue';
    import SwbResultTable from '../query/ResultTable.vue';

    Vue.regist(SwbResultColConf);
    Vue.regist(SwbResultTable);

    let searchConfigData = {};
    export default {
        name: 'swb-servc-req-voucher-list',
        path: '/servc/req/voucher/list',
        avlActions: 'create|appoint_shop|refused|view|search_work_voucher|view_svc_no',
        avlScopes: 'servicer',
        desc: '服务请求单列表',
        data: function () {
            return {
                confKey: 'swb-servc-req-voucher-list',
                configAuto: true,
                theTableHeight: '300',
                //
                needPager: true, //是否需要分页（默认：true）
                multiSelect: false, //是否多选（默认：false）
                multiPageSelect: false, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: "id", //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                rowNoShow: false, //是否显示行号（默认：true）
                rowNoFixed: false, //行号列是否固定（默认：false）

                btnColName: "actions",//操作列名称（如果不设置就不显示操作列）
                //
                btnColTitle: '操作',//操作列标题（默认：'操作'）
                btnColWidth: 200,//操作列宽度（默认：100）
                //
                btnColFixed: false, //操作列是否固定
                //
                pageSize: getDefaultPageSizes().first(),
                pageNumber: 1,
                //
                shopFlag: false,
                refused: null,
                serviverType: null,
                merchantId: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {},
                },
                no: null,
                svcNo: null,
                buyerName: null,
                srcMerchantName: null,
                requestTimeStart: null,
                searchShow: false,
                requestTimeEnd: null,
                merchantServicer: null,
                merchantVendor: null,
                //
                yjctrl: false, //

                comInfo: {},
                back: false,
                treeCollapse: true,
                thisComId: null,
                thisComLevel: null,
                includeSubComs: false,
                initIncludeSubComs: false,
                workServcTypeMap: {}
            }
        },
        created: function () {
            //保持pageSize的一致性
            //
            this.getCurrentUserInfo();
            this.refused = getEnumInfoWith("acceptState", "name", "Refused").value;
            this.merchantServicer = getEnumInfoWith("merchantType", "name", "Servicer").value;
            this.merchantVendor = getEnumInfoWith("merchantType", "name", "Vendor").value;
            this.workServcTypeMap = getEnumMap('workServcType', 'value2text');
            this.getComDetail();
            this.getMerchantCtrlParamValue();
        },
        mounted() {
            let self = this;
            //注册domSizeWatcher
            let thisEl = $(this.$el);
            $(this.$el).addClass('overflow-hidden');
            //
            let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
            domSizeWatcher.setBaseEl(thisEl);
            domSizeWatcher.setMainEl(thisEl.find('[name="result_table"]'), function (width, height, theEl) {
                //根据新主元素的内容大小，调整表格高度
                self.theTableHeight = height;
            });
            //domSizeWatcher.setHrEls();
            domSizeWatcher.setVtEls(thisEl.find('.breadcrumb-layout, .org-tree-layout, [name="query-sort-block"]'));
            domSizeWatcher.start(500);
            //
            this.initResultTable();
        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if(domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            onConfigReady: function () {
                //----------------------搜索排序----------------------------
                //查询排序配置信息
                let workServcTypeList = [{
                    value: null,
                    label: '- 全部 -'
                }];
                let workServcTypes = getEnumList("workServcType");
                if(workServcTypes != null && workServcTypes.length > 0) {
                    workServcTypes.forEach(function (item) {
                        let queryItem = {};
                        queryItem.value = item.value;
                        queryItem.label = item.text;
                        workServcTypeList.push(queryItem);
                    });
                }
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let data = {dataList: workServcTypeList};
                let fieldInfo = {};
                fieldInfo["servcType"] = data;
                query_model_ctrl.updateFields(fieldInfo);
            },
            initResultTable() {
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let resultTable = this.$refs['result_table'];
                //关联[查询排序对象]到结果表格（结果表格可以实时利用最新的 列配置 和 排序信息，同时结果表格列宽也会反向同步到其中的[列配置对象]中去）
                resultTable.setQrySortRef(query_model_ctrl);
                //
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                    'no': function (row, colName, colValue, rowIndex, colConf) {
                        let domHtml = '<span>' + row.no + '</span>';
                        if(row.requestProxied) {
                            domHtml = domHtml + '<i class="table-tips"></i>';
                        }
                        return domHtml;
                    },
                    'svcNo': function (row, colName, colValue, rowIndex, colConf) {
                        let svcNo = row.svcNo || "";
                        if(row.srcMerchantType == self.serviverType && self.checkActionPerm('view_svc_no')) {
                            return '<a href="#" style="color:purple;">' + svcNo + '</a>';
                        } else {
                            return svcNo;
                        }
                    },
                    'merchantVendor': function (row, colName, colValue, rowIndex, colConf) {
                        return row.srcMerchantType == self.merchantVendor ? '<span>' + row.srcMerchantName + '</span>' : '<span></span>';
                    },
                    'servicerComName': function (row, colName, colValue, rowIndex, colConf) {
                        return row.servicerShopFlag ? '<span>' + row.servicerComName + '</span>' : '<span></span>'
                    },
                    'servicerAcceptState': function (row, colName, colValue, rowIndex, colConf) {
                        return row.servicerAcceptState == -1 ? '<span>' + 是 + '</span>' : '<span></span>'
                    },
                    'servicerShopFlag': function (row, colName, colValue, rowIndex, colConf) {
                        return row.servicerShopFlag ? '<span>' + 是 + '</span>' : '<sapn></sapn>'
                    },
                    'workVoucherFlag': function (row, colName, colValue, rowIndex, colConf) {
                        return row.workVoucherFlag ? '<span>' + 是 + '</span>' : '<sapn></sapn>'
                    },
                    'svcDispatched': function (row, colName, colValue, rowIndex, colConf) {
                        return row.svcDispatched ? '<span>' + 是 + '</span>' : '<sapn></sapn>'
                    },
                    'servcType': function (row, colName, colValue, rowIndex, colConf) {
                        return row.servcType != null ? '<span>' + self.workServcTypeMap[row.servcType] + '</span>' : '<sapn></sapn>'
                    },
                    'tag': function (row, colName, colValue, rowIndex, colConf) {
                        return row.tag === '自营服务' ? '<span class="swb-tags swb-tags-warning">' + row.tag + '</span>' : '<span class="swb-tags swb-tags-success">' + row.tag + '</span>'
                    },
                    'actions': function (row, colName, colValue, rowIndex) {
                        let btnList = [];

                        if(row.srcMerchantId == self.merchantId && !row.accepted && !row.cancelled) {
                            btnList.push({
                                name: 'accepted',
                                text: '受理'
                            });
                        }
                        if(self.checkActionPerm('appoint_shop') && !row.workVoucherFlag && !row.servicerShopFlag && self.shopFlag == false && row.servicerAcceptState != -1 && !row.cancelled && row.accepted) {
                            btnList.push({
                                name: 'appoint_shop',
                                text: '指派'
                            });
                        }
                        if(self.checkActionPerm('refused') && row.servicerAcceptState == 0 && !row.workVoucherFlag && !row.servicerShopFlag && !row.cancelled && row.srcMerchantType != self.merchantServicer) {
                            btnList.push({
                                name: 'refused',
                                text: '拒绝'
                            });
                        }
                        if(self.checkActionPerm('view')) {
                            btnList.push({
                                name: 'view',
                                text: '查看详情'
                            });
                        }
                        if(row.tmpNo != null) {
                            btnList.push({
                                name: 'repair_rec',
                                text: '维保记录'
                            });
                        }
                        if(self.checkActionPerm('search_work_voucher') && row.svcDispatched) {
                            btnList.push({
                                name: 'search_work_voucher',
                                text: '查看工单'
                            });
                        }
                        if(self.checkActionPerm('cancel') && row.srcMerchantId == self.merchantId && !row.cancelled && row.cancellable && row.proxied) {
                            btnList.push({
                                name: 'cancel',
                                text: '取消'
                            });
                        }
                        return btnList;
                    }
                }, /* 单元格按钮点击处理函数 */{
                    //*代表可处理未指定事件函数的任意列的按钮/链接的点击
                    'actions': function (row, colName, colValue, rowIndex, btnName) {
                        if(btnName == 'accepted') {
                            self.acceptedServcReqVoucher(row.id);
                        } else if(btnName == 'appoint_shop') {
                            self.appointOption(row);
                        } else if(btnName == 'refused') {
                            self.refusedReqVoucher(row.id);
                        } else if(btnName == 'view') {
                            self.lookServReqVoucher(row);
                        } else if(btnName == 'repair_rec') {
                            self.showDeviceRepairRec(row.tmpNo);
                        } else if(btnName == 'search_work_voucher') {
                            self.searchWorkVoucher(row.id);
                        } else if(btnName == 'cancel') {
                            self.cancelServcReqVoucher(row.id);
                        }
                    }
                });
            },
            renderTable(rows, pagination) {
                //
                let resultTable = this.$refs.result_table;
                //清除数据（如果已经渲染的数据与新的列不是一回事儿）
                //resultTable.clear();
                //同步使用新的自定义列信息
                //resultTable.initMeta(confColList);
                //设置新数据
                let tableData = {
                    rows: rows,
                    pagination: pagination
                };

                resultTable.render(tableData);
            },
            // 单元格点击事件
            rowDblClickHandler: function (row) {
                if(!this.multiSelect) {
                    console.log("----- 双击数据行 ----");
                    console.log(row);
                }
            },
            showTreeCollapse: function (treeCollapse) {
//                console.log(treeCollapse);
                this.treeCollapse = treeCollapse;
            },
            notityChange: function (eventData) {
                if(eventData.id != this.thisComId || this.includeSubComs != eventData.includeSubComs) {
                    this.thisComLevel = eventData.level;
                    this.thisComId = eventData.id;
                    this.includeSubComs = eventData.includeSubComs;
                    this.getComDetail();
                    this.getServcReqVoucherList();
                }
            },
            getComDetail: function () {
                let self = this;
                let postData = {
                    comId: this.thisComId
                };
                servicerApi.getServicerCom(postData, function (result, jqXhr) {
                    if(result.type == 'info') {
                        let data = result.data;
                        self.comInfo = Utils.merge({}, data);
                        self.thisComLevel = data.level;
                        self.thisComId = data.id;
                        self.getServcReqVoucherList();
                    } else {
                        self.$message.error(result.message);
                    }
                });
            },
            //
            queryHandler: function (queryModel) {
                //
                this.queryModel = queryModel;
                this.pageNumber = 1;
                this.getServcReqVoucherList();
            },
            checkActionPerm: function (action, targetPostId) {
                return checkUserActionPerm(Vue.$getClassInfo(this).path, action, targetPostId);
            },
            getMerchantCtrlParamValue: function () {
                let self = this;
                let postData = {};
                postData.code = getEnumInfoWith("ctrlParamCode", "name", "DueServcReqCtrl").code;
                merchtComnApi.getMerchantCtrlParamValue(postData, function (result) {
                    if(result.type == 'info') {
                        //
                        self.yjctrl = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            showSearch: function (flag) {
                this.searchShow = flag;
            },
            getCurrentUserInfo: function () {
                let self = this;
                userApi.getUserInfoByContext({}, function (result) {
                    if(result.type == "info") {
                        self.shopFlag = result.data.scopeEntity.shopFlag;
                        self.serviverType = result.data.scopeEntity.type;
                        self.merchantId = result.data.scopeEntity.id;

                        self.thisComLevel = result.data.scopeEntity.comLevel;
                        self.thisComId = result.data.scopeEntity.comId;

                        self.getServcReqVoucherList();
                    }
                })
            },

            pageNoChangeHandler: function (pageNumber, pageSize) {
                console.log("分页 => 第【" + pageNumber + "】页，大小：" + pageSize);
                //
                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                //
                this.getServcReqVoucherList();
            },
            getServcReqVoucherList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                //
                filterItems.servicerComId = this.thisComId;
                filterItems.comLevel = this.thisComLevel;
                filterItems.includeSubComs = this.includeSubComs;
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;

                let loading = MsgBox.loading();
                servcDisptApi.getEsServcReqVoucherList(postData, function (result) {
                    loading.close();
                    if(result.type == "info") {
                        let servcReqVoucherList = result.data.rows || [];
                        if(servcReqVoucherList != null && servcReqVoucherList.length > 0) {
                            for(let i = 0, count = servcReqVoucherList.length; i < count; i++) {
                                let servcReqVoucher = servcReqVoucherList[i];
                                if(servcReqVoucher.srcMerchantType == self.serviverType) {
                                    servcReqVoucher.tag = "自营服务";
                                } else {
                                    servcReqVoucher.tag = "授权服务";
                                }
                            }
                        }
                        //
                        let pagination = result.data.pagination;
                        self.renderTable(servcReqVoucherList, pagination);

                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            acceptedServcReqVoucher: function (id) {
                let self = this;
                this.$confirm('是否受理当前请求单?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let paramsData = {};
                    paramsData.id = id;
                    let loading = MsgBox.loading();
                    servcDisptApi.setServcReqVoucherAccepted(paramsData, function (result) {
                        if(result.type == "info") {
                            loading.close();
                            self.getServcReqVoucherList();
                            MsgBox.success("受理成功");
                        } else {
                            loading.close();
                            MsgBox.warning("受理失败");
                        }
                    })
                }).catch(function () {
                });
            },
            addServcReqVoucher: function () {
                let self = this;
                let merchantId = self.merchantId;
                let thisDia = Vue.$showDialog({
                    title: '服务请求单 - 添加',
                    width: 900,
                    height: 700,
                    showCloseBtn: true,
                    template: '<div>' +
                    '<swb-servc-req-voucher-save :merchantId="merchantId" ref="svc_servc_req_voucher_save"></swb-servc-req-voucher-save>' +
                    '</div>',
                    data: {
                        id: null,
                        merchantId: merchantId,
                    },
                    methods: {},
                    okClicked: function () {
                        let result = this.$refs.svc_servc_req_voucher_save.getDlgResult();
                        if(result != null && result.type === 'info') {
                            let postData = result.data;
                            postData.planTime = new Date(postData.planTime).format("yyyy-MM-dd HH:mm");
                            let loading = MsgBox.loading();
                            // 根据是否选择的地址判断
                            servcDisptApi.proxySaveServcReqVoucher(postData, function (result) {
                                if(result.type === "info") {
                                    setTimeout(function () {
                                        thisDia.close();
                                        self.getServcReqVoucherList();
                                        MsgBox.success("保存成功");
                                        loading.close();
                                    }, 1000);
                                } else {
                                    loading.close();
                                    MsgBox.warning(result.message);
                                }
                            })

                        } else {
                            MsgBox.warning(result.message);
                            return false;
                        }
                    },
                    lifecycle: {}
                });
            },
            //指派操作
            appointOption: function (row) {
                let self = this;
                Vue.$showDialog({
                    title: '服务请求 - 指派网点',
                    showCloseBtn: true,
                    height: '80%',
                    template: '<div>' +
                    '<swb-servc-req-appoint-store :servcReqVoucherId="id" ref="swb_servc_req_appoint_store"></swb-servc-req-appoint-store>' +
                    '</div>',
                    data: {
                        id: null
                    },
                    methods: {},
                    okClicked: function () {
                        let selfDlg = this;
                        let result = selfDlg.$refs.swb_servc_req_appoint_store.getDlgResult() || {};
                        if(result != null && result.type === 'info') {
                            let postData = {};
                            postData.servicerComId = result.data.id;
                            postData.id = row.id;
                            let loading = MsgBox.loading();
                            servcDisptApi.assignServcReqVoucher(postData, function (result) {
                                if(result.type == "info") {
                                    loading.close();
                                    MsgBox.success("指派公司成功");
                                    self.getServcReqVoucherList();
                                    return true;
                                } else {
                                    loading.close();
                                    MsgBox.failure(result.message);
                                }
                            });
                            return true;
                        } else {
                            MsgBox.failure(result.message);
                        }
                        return false;
                    },
                    lifecycle: {
                        created: function () {
                            this.id = row.id;
                        }
                    }
                });
            },
            lookServReqVoucher: function (row) {
                let self = this;
                let theDlg = Vue.$showDialog({
                    title: '服务请求单 - 查看',
                    showCloseBtn: true,
                    width: 800,
                    height: 1000,
                    template: '<div>' +
                    '<swb-servc-req-voucher-look :id="id" @node-click="clickNode($event)" ref="svc_servc_req_voucher_look"></swb-servc-req-voucher-look>' +
                    '</div>',
                    data: {
                        id: null
                    },
                    methods: {
                        clickNode: function (no) {
                            theDlg.close();
                            self.$router.push({
                                path: SwbServcWorkVoucherList.path,
                                query: {
                                    no: no,
                                    invalid: false
                                }
                            })
                        }
                    },
                    okClicked: function () {
                    },
                    okVisible: false,
                    lifecycle: {
                        created: function () {
                            this.id = row.id;
                        }
                    }
                });
            },
            refusedReqVoucher: function (id) {
                let self = this;
                let theDlg = Vue.$showDialog({
                    title: "拒绝原因",
                    width: 400,
                    height: 270,
                    template: '<div v-loading="loading" element-loading-text="保存中...">' +
                    '<textarea class="width-2x" style="height: 130px" v-model="servicerRefuseDesc"></textarea>' +
                    '</div>',
                    data: {
                        servicerRefuseDesc: null,
                        loading: false,
                    },
                    okClicked: function () {
                        let selfDlg = this;
                        let postData = {};
                        postData.servicerRefuseDesc = selfDlg.servicerRefuseDesc;
                        postData.id = id;
                        postData.servicerAcceptState = self.refused;
                        let loading = MsgBox.loading();
                        servcDisptApi.rejectServcReqVoucher(postData, function (result) {
                            selfDlg.loading = true;
                            if(result.type === "info") {
                                setTimeout(function () {
                                    loading.close();
                                    MsgBox.success("保存成功");
                                    self.getServcReqVoucherList();
                                }, 1000);
                                return true;
                            } else {
                                loading.close();
                                MsgBox.warning(result.message);
                                return false;
                            }
                        })
                    },
                    methods: {},
                });
            },
            searchWorkVoucher: function (id) {
                let self = this;
                self.$router.push({
                    path: SwbServcWorkVoucherList.path,
                    query: {
                        reqVoucherId: id,
                        invalid: false
                    }
                })
            },
            filterTag(value, row) {
                return row.tag === value;
            },
            cancelServcReqVoucher(id){
                let self = this;
                let postData = {};
                postData.id = id;
                self.$prompt('请输入取消原因', '取消原因', {
                    confirmButtonText: '确认',
                    cancelButtonText: '取消',
                }).then(function (data) {
                    postData.cancelCause = data.value;
                    let theLoad = MsgBox.loading();
                    servcDisptApi.cancelServcReqVoucher(postData, function (result) {
                        theLoad.hide();
                        if(result.type == "info") {
                            self.getServcReqVoucherList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {
                });
            },
            showDeviceRepairRec: function (tmpNo) {      // 查看维保记录
                //
                openDeviceRepairRecDlg(tmpNo);
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/servcReq/ServcReqVoucherList.vue